import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=78922c51&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=78922c51&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78922c51",
  null
  
)

export default component.exports